import React from 'react';
import DropdownSelect from '~/components/select/drop-down/drop-down';
export default function FormSelect({ label, name, selectAttributes, options, onValueUpdate }) {
    return (React.createElement("div", { className: "control-group" },
        label && React.createElement("label", { className: "field-label" }, label),
        React.createElement(DropdownSelect, Object.assign({ name: name }, selectAttributes, { options: options, onValueUpdate: onValueUpdate }))));
}
